 function formatCurrencyINR(amount) {
    return 'Rs ' + amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updateBundleTotal() {
    let total = 0;

    document.querySelectorAll('.bundle-checkbox:checked').forEach(cb => {
      const productDiv = cb.closest('.bundle-product');
      const variantSelect = productDiv.querySelector('.variant-select');
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];
      const price = parseFloat(selectedOption.dataset.price || 0);
      total += price;
    });

    document.getElementById('bundleTotal').textContent = formatCurrencyINR(total);
  }

  function updateVariantPriceDisplay(selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const price = parseFloat(selectedOption.dataset.price || 0);
    const priceDisplay = selectElement.closest('.bundle-info').querySelector('.variant-price-display');
    priceDisplay.textContent = formatCurrencyINR(price);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bundle-checkbox').forEach(cb => {
      cb.addEventListener('change', updateBundleTotal);
    });

    document.querySelectorAll('.variant-select').forEach(select => {
      select.addEventListener('change', function () {
        updateVariantPriceDisplay(this);
        updateBundleTotal();
      });

      // Initial price display set (optional for accuracy on load)
      updateVariantPriceDisplay(select);
    });
  });

  function addSelectedToCart() {
    const itemsToAdd = [];

    document.querySelectorAll('.bundle-checkbox:checked').forEach(cb => {
      const productDiv = cb.closest('.bundle-product');
      const variantSelect = productDiv.querySelector('.variant-select');
      const variantId = parseInt(variantSelect.value);
      itemsToAdd.push({ id: variantId, quantity: 1 });
    });

    if (itemsToAdd.length === 0) return alert('Please select at least one item.');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    }).then(res => {
      if (res.ok) {
        window.location.href = '/cart';
      } else {
        alert('Failed to add to cart.');
      }
    });
  }

  // header//
  $(document).ready(function () {
    // Check if we're on the homepage
    if (window.location.pathname === '/' || $('body').hasClass('index')) {
      
      // Listen to scroll event
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $('.sticky-header').addClass('scrolled');
        } else {
          $('.sticky-header').removeClass('scrolled');
        }
      });

    }
  });

  // headerend //

//  



document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.custom-images-section');
  const track = container.querySelector('.scroll-track');

  // Duplicate images until total width > container width * 2
  const originalItems = Array.from(track.children);
  const originalWidth = track.scrollWidth;

  while (track.scrollWidth < container.offsetWidth * 2) {
    originalItems.forEach(item => {
      track.appendChild(item.cloneNode(true));
    });
  }

  let scrollX = 0;
  const speed = 1.5;
  let paused = false;

  // Pause on hover
  container.addEventListener('mouseenter', () => paused = true);
  container.addEventListener('mouseleave', () => paused = false);

  function scrollLoop() {
    if (!paused) {
      scrollX -= speed;
      // Reset scroll position without visual jump
      if (Math.abs(scrollX) >= originalWidth) {
        scrollX = 0;
      }
      track.style.transform = `translateX(${scrollX}px)`;
    }
    requestAnimationFrame(scrollLoop);
  }

  scrollLoop();
});




// slidercode//
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 768) {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const slider = mediaGallery.querySelector('.product__media-list');
    const slides = slider.querySelectorAll('[id^="Slide-template--"]');

    if (slides.length === 0) return;

    let currentIndex = 0;
    const slideCount = slides.length;

    slider.style.scrollBehavior = 'smooth';
    slider.style.overflowX = 'auto';

    function scrollToSlide(index) {
      const slide = slides[index];
      if (slide) {
        const slideLeft = slide.offsetLeft;
        slider.scrollTo({ left: slideLeft, behavior: 'smooth' });
      }
    }

    function jumpToFirstSlide() {
      slider.style.scrollBehavior = 'auto'; // disable smooth for instant jump
      slider.scrollTo({ left: 0 });
      slider.style.scrollBehavior = 'smooth'; // restore smooth scroll
      currentIndex = 0;
    }

    setInterval(() => {
      currentIndex++;
      if (currentIndex >= slideCount) {
        jumpToFirstSlide();
      } else {
        scrollToSlide(currentIndex);
      }
    }, 3000);
  }
});

// variant js //

// variant js end//

// copy code js

function copyCoupon(e) {
  e.preventDefault(); // Prevent page refresh on link click
  const code = document.getElementById("couponCode").textContent;
  const btn = document.getElementById("copyBtn");

  navigator.clipboard.writeText(code).then(() => {
    btn.textContent = "Copied!";
    btn.style.color = "green";

    setTimeout(() => {
      btn.textContent = "Copy";
      btn.style.color = "#e50072";
    }, 2000);
  }).catch(err => {
    console.error("Failed to copy: ", err);
  });
}

// innerprivaypage//
$(document).ready(function() {
    // Check if URL contains "/policies/"
    if (window.location.pathname.indexOf('/policies/') === 0) {
        $('body').addClass('policy-page');
    }
});
// innerprivaypage end//



// mega mmenu end//

// fbt section bundle product

document.addEventListener("DOMContentLoaded", function () {
  function updateBundleSummary() {
    let total = 0;
    let compareTotal = 0;

    document.querySelectorAll(".bundle-product-main").forEach(el => {
      const checkbox = el.querySelector(".bundle-checkbox");
      const select = el.querySelector(".variant-select");
      const priceDisplay = el.querySelector(".variant-price-display");

      if (select && select.options.length > 0) {
        const selected = select.options[select.selectedIndex];
        const price = parseFloat(selected.dataset.price || 0);
        const compare = parseFloat(selected.dataset.compare || 0);

        // Always update displayed price
        priceDisplay.innerText = `Rs. ${price.toFixed(2)}`;

        if (checkbox && checkbox.checked) {
          total += price;
          compareTotal += compare > 0 ? compare : price;
        }
      }
    });

    const bundleTotal = document.getElementById("bundle-total");
    const bundleSave = document.getElementById("bundle-save");

    if (bundleTotal) {
      bundleTotal.innerHTML = compareTotal > total
        ? `<del>Rs. ${compareTotal.toFixed(2)}</del> Rs. ${total.toFixed(2)}`
        : `Rs. ${total.toFixed(2)}`;
    }

    if (bundleSave && compareTotal > total) {
      bundleSave.innerText = `You save: Rs. ${(compareTotal - total).toFixed(2)}`;
    }
  }

  // Initial summary update
  updateBundleSummary();

  // Event listeners
  document.querySelectorAll(".bundle-checkbox, .variant-select").forEach(el => {
    el.addEventListener("change", updateBundleSummary);
  });

  // Add to Cart button click
  document.getElementById("bundle-add").addEventListener("click", function () {
    let items = [];

    document.querySelectorAll(".bundle-product-main").forEach(el => {
      const checkbox = el.querySelector(".bundle-checkbox");
      const select = el.querySelector(".variant-select");

      if (checkbox && checkbox.checked && select) {
        items.push({
          id: select.value,
          quantity: 1
        });
      }
    });

    if (items.length) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
      })
      .then(response => response.json())
      .then(data => {
        // Update cart icon
        fetch("/cart.js")
          .then(res => res.json())
          .then(cart => {
            const updatedQuantity = cart.item_count;
            const cartIcon = document.getElementById("cart-icon-bubble");

            if (cartIcon) {
              cartIcon.querySelector(".cart-count-bubble")?.remove();
              cartIcon.querySelector(".visually-hidden")?.insertAdjacentHTML(
                "afterend",
                `<div class="cart-count-bubble">${updatedQuantity}</div>`
              );
            }

            // Open cart drawer
            const drawer = document.querySelector("cart-drawer");
            if (drawer) {
              drawer.classList.remove("is-empty");
              drawer.classList.add("active");

              fetch(window.location.href)
                .then(res => res.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, "text/html");
                  const cartDrawer = doc.querySelector("#CartDrawer");
                  if (cartDrawer) {
                    drawer.innerHTML = cartDrawer.innerHTML;
                  }
                });
            }
          });
      });
    }
  });
});


// <!-- textaniamtion -->
    const spans = document.querySelectorAll('.dynamic-text span');
    let index = 0;

    function animateText() {
      spans.forEach(span => {
        span.classList.remove('active');
        span.style.top = '100%';
        span.style.opacity = '0';
      });
      if (index < spans.length) {
        const currentSpan = spans[index];
        currentSpan.classList.add('active');
        setTimeout(() => {
          animateText();
          index = (index + 1) % spans.length;
        }, 2000); // 2 seconds per word
      }
    }

    // Start animation
    animateText();
// <!-- textaniamtion -->

// ===========================
//  SCROLL-TRIGGER ANIMATION
//  Requires: GSAP + ScrollTrigger + SplitType
// ===========================
document.addEventListener("DOMContentLoaded", () => {

  /**
   * Utility to create a ScrollTrigger for timelines.
   * @param {HTMLElement} triggerElement - The element to watch.
   * @param {GSAPTimeline} timeline - The animation timeline to control.
   */
  function createScrollTrigger(triggerElement, timeline) {
    // Reset animation when scrolling back up
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top bottom",
      onLeaveBack: () => {
        timeline.progress(0); // reset to start
        timeline.pause();
      },
    });

    // Play animation when element reaches 50% of viewport height
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top 50%", // changed from 80% → starts later on screen
      markers: true,    // DEBUG: Remove when done
      onEnter: () => timeline.play(),
    });
  }

  // =====================================
  // 1️⃣ SPLIT TEXT INTO WORDS & CHARS
  // =====================================
  const splitTypeElements = document.querySelectorAll("[text-split]");
  splitTypeElements.forEach((el) => {
    new SplitType(el, {
      types: "words, chars",
      tagName: "span", // Wraps each piece in a <span>
    });
  });

  // =====================================
  // 2️⃣ WORD SLIDE-UP ANIMATION
  // =====================================
  const wordsSlideUpElements = document.querySelectorAll("[words-slide-up]");
  wordsSlideUpElements.forEach((el) => {
    const tl = gsap.timeline({ paused: true });
    const words = el.querySelectorAll(".word");

    tl.from(words, {
      opacity: 0,
      yPercent: 100,    // Slide from below
      duration: 0.5,
      ease: "back.out(2)",
      stagger: { amount: 0.5 },
    });

    createScrollTrigger(el, tl);
  });

  // =====================================
  // 3️⃣ SCRUB EACH WORD ON SCROLL
  // =====================================
  const scrubEachWordElements = document.querySelectorAll("[scrub-each-word]");
  scrubEachWordElements.forEach((el) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top 50%",   // Start when element reaches middle
        end: "top 20%",     // End before reaching top
        scrub: true,        // Link animation to scroll position
        markers: false,      // DEBUG: Remove when done
      },
    });

    const words = el.querySelectorAll(".word");
    tl.from(words, {
      opacity: 0.2,
      duration: 0.2,
      ease: "power1.out",
      stagger: { each: 0.4 },
    });
  });

  // =====================================
  // 4️⃣ ENSURE BASE OPACITY FOR TEXT-SPLIT
  // =====================================
  const textSplitElements = document.querySelectorAll("[text-split]");
  textSplitElements.forEach((el) => {
    gsap.set(el, { opacity: 1 }); // Make sure container stays visible
  });
});



// hero-animation.js
document.addEventListener('DOMContentLoaded', function() {

  // Helper to load scripts dynamically
  function loadScript(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    document.head.appendChild(script);
  }

  // Main animation function
  function initHeroAnimation() {
    if (!window.gsap || !window.ScrollTrigger) return;

    gsap.registerPlugin(ScrollTrigger);

    const heroMain = document.querySelector('.home-hero__main');
    const heroBg   = document.querySelector('.home-hero__bg');

    if (!heroMain || !heroBg) return;

    // Set video height
    heroBg.style.height = "86vh";

    // Animate text on scroll
    gsap.to(heroMain, {
      y: "-86vh",
      ease: "none",
      scrollTrigger: {
        trigger: ".home-hero__wrap",
        start: "top top",
        end: "+=86vh",
        scrub: true,
        pin: heroBg,
        pinSpacing: true
      }
    });
  }

  // Load GSAP + ScrollTrigger dynamically if not present
  if (!window.gsap) {
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js", function() {
      loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js", initHeroAnimation);
    });
  } else if (!window.ScrollTrigger) {
    loadScript("https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js", initHeroAnimation);
  } else {
    initHeroAnimation();
  }

});


// founderpage text
// Split the text inside your heading <p> into <span> wrappers
// Select all elements with our custom attribute
document.querySelectorAll("[data-animate='words']").forEach(el => {
  const text = el.innerHTML.trim();
  const words = text.split(" ");

  // wrap words in <span>
  el.innerHTML = words
    .map(w => `<span style="display:inline-block; transform:translateY(100%); opacity:0;">${w}&nbsp;</span>`)
    .join("");

  // animate each element on scroll
  gsap.fromTo(el.querySelectorAll("span"),
    { y: "100%", opacity: 0 },
    {
      y: "0%",
      opacity: 1,
      duration: 1,
      ease: "power3.out",
      stagger: 0.12,
      scrollTrigger: {
        trigger: el,
        start: "top 70%", // start when 30–40% visible
        toggleActions: "play none none none"
      }
    }
  );
});


// founderpage text end


//  add cart drawer upsell products

// Custom money format
function formatMoney(cents) {
  var value = (cents / 100).toFixed(2);
  return "Rs. " + value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// On variant change -> update price + compare_at_price
$(document).on('change', '.variant-dropdown', function () {
  var $product = $(this).closest('.product-item');
  var variants = JSON.parse($product.attr('data-variants'));

  var selectedVariantId = $(this).val();
  var matchedVariant = variants.find(function(v) {
    return v.id == selectedVariantId;
  });

  if (matchedVariant) {
    // Update hidden input
    $product.find('.variant-select').val(matchedVariant.id);

    // Update current price
    $product.find('.variant-price').text(
      formatMoney(matchedVariant.price)
    );

    // Update compare at price
    if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
      $product.find('.variant-compare-price').text(
        formatMoney(matchedVariant.compare_at_price)
      ).show();
    } else {
      $product.find('.variant-compare-price').text("").hide();
    }
  }
});

// Add to cart
$(document).on('click', '.add-to-cart-btn', function () {
  var $product = $(this).closest('.product-item');
  var variantId = $product.find('.variant-select').val();
  var quantity = 1;

  if (!variantId) {
    alert('Please select a variant.');
    return;
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: { quantity: quantity, id: variantId },
    dataType: 'json',
    success: function () {
      $.getJSON('/cart.js', function (cart) {
        const updatedQuantity = cart.item_count;
        $("#cart-icon-bubble .cart-count-bubble").remove();
        $("#cart-icon-bubble .visually-hidden").after(
          '<div class="cart-count-bubble">' + updatedQuantity + '</div>'
        );
        const $drawer = $('.cart-drawer');
        if ($drawer.length > 0) {
          $drawer.load(window.location.href + ' .cart-drawer > *', function () {
            $drawer.removeClass('is-empty').addClass('active');
          });
        }
        if (typeof openCartDrawer === "function") {
          openCartDrawer();
        }
      });
    },
    error: function (err) {
      alert('Error adding to cart. Please try again.');
      console.error(err);
    }
  });
});




